// import React, { Fragment, Component } from "react";
// import Breadcrumb from "../../components/common/breadcrumb";
// import BrandForm from "./components/form";
// import BrandTable from "./components/table";
// import BrandCategoryService from "../../services/brandCategoryService";
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
// import $ from "jquery";
// // import store from "store";

// class CreateBrand extends Component {
//   state = {
//     infoData: {},
//     isEdit: true,
//   };
//   componentWillMount() {
//     const { match } = this.props;
//     const { params } = match;
//     const { brandId } = params;
//     this.setState({ loader: true, brandId }, function () {
//       this.callApiInfo();
//     });
//   }
//   componentDidUpdate() {
//     const { match } = this.props;
//     const { params } = match;
//     const { brandId } = params;
//     if (this.state.brandId !== brandId) {
//       this.setState(
//         {
//           loader: true,
//           infoData: [],
//           searchText: "",
//           page: 0,
//           pageSize: 10,
//           totalRecords: 0,
//           startDate: "",
//           endDate: "",
//           brandId: brandId,
//         },
//         function () {
//           this.callApiInfo();
//         }
//       );
//     }
//   }
//   callApiInfo = () => {
//     const { brandId } = this.state;
//     BrandCategoryService.fetchBrandsInfo(brandId).then((response) => {
//       if (!response.error) {
//         this.setState({
//           modalFormShow: false,
//           loader: false,
//           infoData: response?.data,
//           imageUrl: response?.data?.imageUrl,
//         });
//       } else {
//         this.setState({
//           loader: false,
//           infoData: {},
//           imageUrl: undefined,
//         });
//       }
//     });
//     this.setState({ loader: false });
//   };
//   addBrandForm = (data) => {
//     const { isEdit, info, brandId, imageUrl } = this.state;
//     console.log("This state", this.state)
//     this.setState({ loader: true });
//     data["imageUrl"] = imageUrl;
//     // data["brandId"] = isEdit ? info._id : undefined;
//     data["brandId"] = isEdit ? brandId : undefined;
//     var method = isEdit ? "PUT" : "POST";
//     BrandCategoryService.addBrandInfo(data, method).then((response) => {
//       if (!response.error) {
//         this.props.history.push("/brands/all");
//       }
//     });
//   };
//   onClickToggle = () => {
//     this.setState({ modalFormShow: false });
//   };
//   onChangeImage = (imageUrl) => {
//     this.setState({ imageUrl: imageUrl });
//   };

//   removeImage = () => {
//     this.setState({ imageUrl: undefined });
//   };

//   onChangeUrl = (name, url) => {
//     if (
//       (name && name !== "") ||
//       (url && url !== "undefined") ||
//       (url === "" && url !== "undefined")
//     ) {
//       var { infoData, urlEdit } = this.state;
//       var stringUrl = "";
//       var urlEdit1 = true;
//       if (name && !urlEdit) {
//         stringUrl = name.toLowerCase();
//         urlEdit1 = urlEdit || urlEdit1;
//       } else if (url && url !== "undefined") {
//         stringUrl = url.toLowerCase();
//         urlEdit1 = true;
//       } else if (url === "" && url !== "undefined") {
//         stringUrl = url;
//         urlEdit1 = false;
//       } else {
//         stringUrl = infoData["sUrl"] || "";
//         urlEdit1 = urlEdit || urlEdit1;
//       }
//       stringUrl = stringUrl.replace(/ /g, "_");
//       stringUrl = stringUrl.replace(/,/g, "_");
//       stringUrl = stringUrl.replace(/__/g, "_");
//       if (infoData) {
//         infoData["sUrl"] = stringUrl;
//       } else {
//         infoData = { sUrl: stringUrl };
//       }
//       this.setState({ infoData: infoData, urlEdit: urlEdit1 });
//     }
//   };

//   onChangeActive = (brandId, value, index) => {
//     console.log({ brandId, value });
//     const { infoData } = this.state;
//     this.setState({ loader: true });
//     BrandCategoryService.onBrandReady(brandId, value).then((response) => {
//       if (!response.error) {
//         infoData[index].public = value;
//         this.setState({ infoData, loader: false });
//         // this.props.history.push("/products/all");
//       }
//       this.setState({ loader: false });
//     });
//   };
//   render() {
//     const {
//       brandId,
//       infoData,
//       modalFormShow,
//       loader,
//       info,
//       index,
//       isEdit,
//       imageUrl,
//     } = this.state;
//     const { loading, page, pageSize, totalRecords } = this.state;

//     const brandFormProps = {
//       info: infoData || {},
//       active: this.state.active,
//       imageUrl: imageUrl,
//       onChangeImage: this.onChangeImage,
//       removeImage: this.removeImage,
//       onChangeUrl: this.onChangeUrl,
//       searchProductUrl: "",
//       searchUrlStatus: false,
//       isEdit: this.state.isEdit,
//       onChangeBrandId: (id) => {
//         console.log({ id });
//       },
//       onClickConfirm: (data) => {
//         //console.log(data)
//         this.addBrandForm(data);
//       },
//       onClickActive: (active) => {
//         this.setState({ active });
//       },
//       // BrandForm: infoData,
//     };
//     return (
//       <Fragment>
//         <Breadcrumb title={"Update"} parent="Brand" />
//         <div className="container-fluid">
//           <div className="row">
//             <div className="col-sm-12">
//               <div className="card border-0" style={{boxShadow:"1px 5px 24px 0 rgba(68, 102, 242, .05)", padding:"30px"}}>
//                 {/* <div className="card-header">
//                   <h5>Select Multiple Data</h5>
//                 </div> */}

//                 {loader && (
//                   <div
//                     style={{
//                       position: "fixed",
//                       top: "50%",
//                       right: "45%",
//                       zIndex: "+999",
//                     }}
//                   >
//                     <div className="loader bg-white">
//                       <div className="whirly-loader"> </div>
//                     </div>
//                   </div>
//                 )}

//                 <BrandForm {...brandFormProps} />
//               </div>
//             </div>
//           </div>
//         </div>
//       </Fragment>
//     );
//   }
// }

// export default CreateBrand;

import React, { Fragment, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Breadcrumb from "../../components/common/breadcrumb";
import BrandForm from "./components/form";
import BrandCategoryService from "../../services/brandCategoryService";

const CreateBrand = () => {
  const history = useHistory();
  const { brandId } = useParams();

  const [infoData, setInfoData] = useState({});
  const [imageUrl, setImageUrl] = useState();
  const [loader, setLoader] = useState(false);
  const [isEdit] = useState(true);
  const [urlEdit, setUrlEdit] = useState(true);
  const [active, setActive] = useState(false);

  /* ================= FETCH BRAND INFO ================= */

  useEffect(() => {
    if (brandId) {
      setLoader(true);
      callApiInfo(brandId);
    }
  }, [brandId]);

  const callApiInfo = (id) => {
    BrandCategoryService.fetchBrandsInfo(id).then((response) => {
      if (!response?.error) {
        setInfoData(response.data || {});
        setImageUrl(response?.data?.imageUrl);
      } else {
        setInfoData({});
        setImageUrl(undefined);
      }
      setLoader(false);
    });
  };

  /* ================= SUBMIT ================= */

  const addBrandForm = (data) => {
    setLoader(true);

    data.imageUrl = imageUrl;
    data.brandId = isEdit ? brandId : undefined;

    const method = isEdit ? "PUT" : "POST";

    BrandCategoryService.addBrandInfo(data, method).then((response) => {
      setLoader(false);
      if (!response?.error) {
        history.push("/brands/all");
      }
    });
  };

  /* ================= IMAGE ================= */

  const onChangeImage = (url) => {
    setImageUrl(url);
  };

  const removeImage = () => {
    setImageUrl(undefined);
  };

  /* ================= SLUG ================= */

  const onChangeUrl = (name, url) => {
    if (
      (name && name !== "") ||
      (url && url !== "undefined") ||
      (url === "" && url !== "undefined")
    ) {
      let stringUrl = "";
      let urlEdit1 = true;

      if (name && !urlEdit) {
        stringUrl = name.toLowerCase();
      } else if (url && url !== "undefined") {
        stringUrl = url.toLowerCase();
        urlEdit1 = true;
      } else if (url === "") {
        stringUrl = "";
        urlEdit1 = false;
      } else {
        stringUrl = infoData?.sUrl || "";
      }

      stringUrl = stringUrl
        .replace(/ /g, "_")
        .replace(/,/g, "_")
        .replace(/__/g, "_");

      setInfoData((prev) => ({
        ...prev,
        sUrl: stringUrl,
      }));

      setUrlEdit(urlEdit1);
    }
  };

  /* ================= ACTIVE ================= */

  const onChangeActive = (brandId, value, index) => {
    setLoader(true);

    BrandCategoryService.onBrandReady(brandId, value).then((response) => {
      if (!response?.error) {
        setInfoData((prev) => {
          const updated = [...prev];
          updated[index].public = value;
          return updated;
        });
      }
      setLoader(false);
    });
  };

  /* ================= PROPS ================= */

  const brandFormProps = {
    info: infoData || {},
    active,
    imageUrl,
    onChangeImage,
    removeImage,
    onChangeUrl,
    searchProductUrl: "",
    searchUrlStatus: false,
    isEdit,
    onClickConfirm: addBrandForm,
    onClickActive: setActive,
  };

  /* ================= UI ================= */

  return (
    <Fragment>
      <Breadcrumb title="Update" parent="Brand" />

      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div
              className="card border-0"
              style={{
                boxShadow: "1px 5px 24px 0 rgba(68, 102, 242, .05)",
                padding: "30px",
              }}
            >
              {loader && (
                <div
                  style={{
                    position: "fixed",
                    top: "50%",
                    right: "45%",
                    zIndex: 999,
                  }}
                >
                  <div className="loader bg-white">
                    <div className="whirly-loader" />
                  </div>
                </div>
              )}

              <BrandForm {...brandFormProps} />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CreateBrand;

